import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=0d6dc4f6&scoped=true&"
import script from "./AppVideo.vue?vue&type=script&lang=js&"
export * from "./AppVideo.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo.vue?vue&type=style&index=0&id=0d6dc4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6dc4f6",
  null
  
)

export default component.exports